import { HelpIcon, TooltipText } from '../../../components'
import { Section } from '../styles'

const ReachedRetirementAge = () => {
  return (
    <Section.ActionItemsMessage>
      <Section.Triangle />{' '}
      <Section.ActionItemMessageText>
        Looks like you've reached your stated retirement age-Congratulations! Check your next
        steps:&nbsp;
        <HelpIcon tooltip={TooltipText.areYouRetired()} />
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default ReachedRetirementAge
